// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__1SpXj","navSticky":"Nav_navSticky__2k5Im"};